import { registerQuery } from 'data-fetching-client';
import HttpClient from 'flow-doctor-lib/constants/HttpClient';
export const GET_SURVEY_MONKEY_SURVEYS = registerQuery({
  fieldName: 'surveyMonkeySurveys',
  args: ['portalId'],
  fetcher({
    portalId
  }) {
    return HttpClient.get('surveymonkey/v1/surveys/questions', {
      query: {
        portalId,
        syncEnabled: true
      }
    });
  }
});